const {Component} = require("react");
const PropTypes = require("prop-types");
const store = require("stores/ReviewsStore");
const {observer} = require("mobx-react");
const Rating = require("components/widgets/Rating");
const Stars = require("components/mixins/Stars");
const RatingTbd = require("components/mixins/RatingTbd");
const {classList} = require("helpers/html");
const {avg} = require("helpers/array");
const userStore = require("stores/UserStore");
const {decodeObservable} = require("helpers/object");

function Review({sender, score, contents}) {
	const innerHtml = {__html: contents};

	return (
		<div className="review">
			<div className="review-top">
				<p>{sender.nickname} {sender.age}år</p>
				<Rating value={parseInt(score)} interactive={false}/>
			</div>
			<div className="review-desc">
				<p dangerouslySetInnerHTML={innerHtml}></p>
			</div>
		</div>
	);
}

@observer
class ReviewList extends Component {

	static get propTypes() {
		return {
			profileName: PropTypes.string.isRequired
		};
	}

	get className() {
		return classList(
			"reviews-list",
			"all-reviews",
			this.props.className,
			store.collection.length === 0 ? "empty" : null
		);
	}

	get items() {
		const collection = decodeObservable(store.collection);

		// Show authenticated user's reviews first if logged in
		if (userStore.exists()) {
			const userId = userStore.get("id");

			return collection.sort((a, b) => {
				if (a.sender.id === userId) {
					return -1;
				}

				if (b.sender.id === userId) {
					return 1;
				}

				return 0;
			});
		}

		return collection;
	}

	get grammarName() {
		const name = this.props.profileName;
		if (!name) return;

		const endsWithS = name.slice(-1).toLowerCase() === 's';

		return endsWithS ?
			name + "'" :
			name + "s";
	}

	renderAverageScore() {
		const averageScore = Math.round(avg(store.collection, "score"));

		if (averageScore === 0.0) {
			return (<RatingTbd/>);
		}

		return (<Stars filled={averageScore}/>);
	}

	renderItems() {
		return store.collection.map(item => {
			return (<Review key={item.id} {...item}/>)
		});
	}

	render() {
		return (
			<div className={this.className}>
				<div className="top-bar">
					<h4>{this.grammarName} bedømmelser</h4>
					<div className="rating">
						<p>{store.collection.length} Anmeldelser</p>
						{this.renderAverageScore()}
					</div>
				</div>
				{this.renderItems()}
			</div>
		)
	}

}

module.exports = ReviewList;



// WEBPACK FOOTER //
// ./resources/js/components/frontend/ReviewList.js